module.exports = __webpack_public_path__ + "img/about-doubts.71d31bb1.svg";